import {Component, EventEmitter, Input, OnInit, Output, TemplateRef,} from '@angular/core';
import {ColorsConst} from 'src/app/core';

@Component({
  selector: 'app-event-card',
  templateUrl: './event-card.component.html',
  styleUrls: ['./event-card.component.less'],
})
export class EventCardComponent implements OnInit {
  eventDetailsTpl: TemplateRef<any>;
  eventDetailsText: string;
  @Input() avatarIconColorhex: string;
  @Input() avatarIconBgColorhex: string = ColorsConst.white;
  @Input() resourceName: string;
  @Input() eventName: string;
  @Input() ressourceDetailTitle: string;
  @Input() ressourceDetailId: string;
  @Input() ressourceDetailTitleSecondary: string;
  @Input() ressourceDetailIdSecondary: string;
  @Input() eventTs: string;
  @Input() requesterName: string;
  @Input() hasLinkResDetail: boolean;
  @Input() hasLinkResDetailSecondary: boolean;
  @Output() onResDetailsLinkCliked: EventEmitter<null> = new EventEmitter();
  @Output() onResDetailsSecondaryLinkCliked: EventEmitter<null> =
    new EventEmitter();

  constructor() {
  }

  @Input()
  set eventDetails(value: string | TemplateRef<any>) {
    if (value instanceof TemplateRef) {
      this.eventDetailsTpl = value;
    } else {
      this.eventDetailsText = value;
    }
  }

  ngOnInit(): void {
  }

  linkClicked() {
    this.onResDetailsLinkCliked.emit();
  }

  linkSecondaryClicked() {
    this.onResDetailsSecondaryLinkCliked.emit();
  }
}
